import React from 'react'

import {
  GTM_ENV_VAR as GEV,
  PAGE_TYPES,
} from '../../../../lib/eventTrackerFunction'

const useTracker = ({ data, track, query }) => {
  const trackJWCMemberLogin = React.useCallback(() => {
    track({
      [GEV.PAGE_TYPE]: PAGE_TYPES.JWC_HOMEPAGE,
      [GEV.SCREEN_NAME]: `${PAGE_TYPES.JWC_HOMEPAGE}_Barcode`,
      [GEV.EVENT_CAT]: 'Ecommerce-Engagement',
      [GEV.EVENT_ACTION]: 'Successful_Login_Barcode',
      [GEV.EVENT_LABEL]: 'Loc=JWCHome-Barcode',
      [GEV.JWC_ID]: data && data.userId,
      [GEV.ASSET_TYPE]: 'JWC',
      [GEV.JWC_REFERRER]: document.referrer,
    })
  }, [data, track])

  const trackOrderSuccess = React.useCallback(
    (action, orderString) => {
      const orderType = orderString === 'Renewal' ? 'Renewal' : 'Register'

      const common = {
        [GEV.PAGE_TYPE]: PAGE_TYPES.JWC_HOMEPAGE,
        [GEV.EVENT_CAT]: 'Ecommerce-Conversion',
        [GEV.JWC_ID]: data && data.userId,
        [GEV.ASSET_TYPE]: 'JWC',
        [GEV.JWC_REFERRER]: document.referrer,
      }

      let options

      if (action === 'visit') {
        options = {
          [GEV.EVENT_ACTION]: `${orderType}_Successful_Page`,
          [GEV.EVENT_LABEL]:
            orderType === 'Renewal'
              ? 'Loc=JWCHomeRenewSuccess'
              : 'Loc=JWCHomeRegSuccess',
        }
      }

      if (action === 'continue') {
        options = {
          [GEV.EVENT_ACTION]:
            orderType === 'Renewal'
              ? 'Click_Cont_RenewSuccessful'
              : 'Click_Cont_RegSuccessful',
          [GEV.EVENT_LABEL]:
            orderType === 'Renewal'
              ? 'Loc=JWCHomeRenewSuccess-Cont'
              : 'Loc=JWCHomeRegSuccess-Cont',
        }
      }

      track({
        [GEV.SCREEN_NAME]: `${PAGE_TYPES.JWC_HOMEPAGE}_${orderType}_Success`,
        ...common,
        ...options,
      })
    },
    [data, track]
  )

  React.useEffect(() => {
    if (!query.orderSuccess) {
      trackJWCMemberLogin()
    } else {
      trackOrderSuccess('visit', query.orderSuccess)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { trackJWCMemberLogin, trackOrderSuccess }
}

export default useTracker
